import React, { useId } from 'react'
import PropTypes from 'prop-types'

const BadgeEditIcon = React.forwardRef(function BadgeEditIcon(props, ref) {
  const { color, size, ...otherProps } = props

  return (
    <svg
      ref={ref}
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill={color}
      {...otherProps}
    >
      <path d="M22 1H2C1.45 1 1 1.45 1 2C1 20.61 11.36 22.89 11.8 22.98C11.87 22.99 11.93 23 12 23C12.07 23 12.13 22.99 12.2 22.98C12.64 22.89 23 20.61 23 2C23 1.45 22.55 1 22 1ZM12 20.97C10.65 20.58 3.33 17.79 3.01 3H20.99C20.67 17.79 13.35 20.58 12 20.97Z"></path>
      <path d="M8 15H10L16 9 14 7 8 13V15ZM18 7C18 7 19 6 18 5 17 4 16 5 16 5L15 6 17 8 18 7Z"></path>
    </svg>
  )
})

BadgeEditIcon.propTypes = {
  color: PropTypes.string,
  size: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
}

BadgeEditIcon.defaultProps = {
  color: 'currentColor',
  size: '24'
}

export default BadgeEditIcon
